import { Stack, Text, xcss } from '@atlaskit/primitives';
import { messages } from '@databases/intl/messages';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import filterFunnelIllustration from '../../../../assets/filter-funnel.svg';

const containerStyles = xcss({
  textAlign: 'center',
  paddingTop: 'space.800',
  paddingBottom: 'space.800',
});

export const JiraFilterLoadingState: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <Stack
      alignBlock="center"
      alignInline="center"
      space="space.150"
      xcss={containerStyles}
    >
      <img src={filterFunnelIllustration} alt="" role="presentation" />
      <Text color="color.text.subtle" size="large" weight="bold">
        {formatMessage(messages['table-layout.filtering-entries'])}
      </Text>
    </Stack>
  );
};
